import styles from './style.css'

class Report extends React.Component {
  render () {
    let pathnameSplit = this.props.location.pathname.split('/')
    let additionalClassName = pathnameSplit.slice(1).join('-')

    return (
      <div className={styles['container-full-nosub']} id='reports'>
        <div className={`${styles['container']} ${styles[additionalClassName]}`}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Report



// WEBPACK FOOTER //
// ./app/pages/Reports/Report.js